// extracted by mini-css-extract-plugin
export default {"gridBox":"new_gridBox__75LUb"};